import Styles from './EmptyPreview.module.scss'
import cx from 'classnames'

interface Props {
  className?: string
}

export const EmptyDesign = ({ className }: Props) => (
  <div className={cx(Styles.empty, className)}>
    <div className={Styles.emptyDesign} />
    <div className={Styles.emptyText}>This design is empty</div>
  </div>
)
